import React from 'react';
import { AppBar, HeaderTabs, ScrollableViewport } from '@ihsm/ui-shared';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { PageContent } from 'shared/components/PageContent';
import { PortfoliosFundTable } from '../components/PortfoliosFundTable';
import { usePortfolioPage } from '../hooks';
import { BENCHMARK_PAGE_OPTIONS, FUNDS_TABS } from '../constants';
import { Controls } from '../components/Controls';

export const PortfoliosBenchmark: React.FC = (): JSX.Element => {
  const { exporterRef, onExport } = usePortfolioPage();

  return (
    <PageContent
      headerControls={
        <AppBar menuItems={BENCHMARK_PAGE_OPTIONS}>
          <HeaderTabs items={FUNDS_TABS} />
        </AppBar>
      }
      viewControls={<Controls onExport={onExport} />}
    >
      <InnerPagePadding>
        <ScrollableViewport vertical>
          <PortfoliosFundTable gridExportRef={exporterRef} />
        </ScrollableViewport>
      </InnerPagePadding>
    </PageContent>
  );
};
